<!--Top Section-->
<div class="pt-2"></div>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <h1 class="h2">Business Plan Builder</h1>
</div>
<div class="row d-flex aligh-items-center">
  <div class="col">
    <mat-expansion-panel [expanded]="true"
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Best tips on how to use the builder
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p> <b class="red">PLEASE READ: 
           CLICK 'SAVE ALL' TO SAVE YOUR CHANGES - ELSE IT WON'T SAVE!</b>
         <li>Use the instructions and examples to guide your writing. </li>
         <li>The example busines plan references a service-based design firm.</li>
         <li>We’ve provided Research action items where necessary. Look for the search icon <mat-icon aria-hidden="false">search</mat-icon></li>
        <li>If your business has existing operations, consider changing the language to present tense. </li>
        <li>You can download the plan and edit the doc as needed once finished. Remember to save your changes!</li>
      </p>
    </mat-expansion-panel>
  </div>
      <!--buttons-->
  <div class="col">
      <div class="row ">
        <div class="btn-group pt-3 pr-3">
          <button class="block" mat-raised-button color="primary" id="printbtn" (click)="saveToFireB()">Save All</button>
        </div>
        <div class="btn-group pt-3 pr-3">
          <button class="block" mat-raised-button color="primary" id="printbtn" (click)="exportOnClick('pdf')">Download PDF</button>
         </div>
         <div class="btn-group pt-3 pr-3">
           <button class="block" mat-raised-button color="primary" id="printbtn" (click)="exportOnClick('docx')">Download DOCX</button>
         </div>
         
        <!--<div class="btn-group pt-3 pr-3">
          <button class="block" mat-raised-button color="primary" id="printbtn" (click)="ResetForm()">Clear Form</button>
        </div> Taken out because it clears user info and should have an alert to ask are you sure-->
    </div>
  </div>
</div>
<div class="row ">
<div class="col-6">
<div id="element-to-export">
<div class="pt-5">
<div label="Business Plan">
    <div>
      <h2 class="results-headers">{{dataBplan?.bplanBusiName}}'s Business Plan</h2>
     <h4 class="results-headers">Written {{todaysDate}}</h4>
     <h4 class="results-headers">Business Address: {{dataBplan?.bplanBusiStreet}} {{dataBplan?.bplanBusiStreet2}} {{dataBplan?.bplanBusiCity}}, {{dataBplan?.bplanBusiState}} {{dataBplan?.bplanBusiZipcode}} </h4>
    </div>
    <div class="ExecutiveSummary">
      <h3 class="results-headers"><b>Executive Summary</b></h3>
     <div>
         <p class="d-flex">
              {{dataBplan?.bplanBusiName}} is a {{dataBplan?.bplanBusiCity}}, {{dataBplan?.bplanBusiState}} 
              based {{dataBplan?.bplanOfferSummary}} {{dataBplan?.bplanBusiType}}. {{dataBplan?.bPlanCustomerCharacterstic}}
              {{dataBplan?.bplanBusiName}} will operate out of {{dataBplan?.bplanBusiOperationsType}}
              with an address located at {{dataBplan?.bplanBusiStreet}} {{dataBplan?.bplanBusiStreet2}} {{dataBplan?.bplanBusiCity}}, {{dataBplan?.bplanBusiState}} {{dataBplan?.bplanBusiZipcode}}. 
              <!--  <mat-form-field class="formInText">
                <mat-select formControlName="bplanBusiOperationsType">
                  <mat-option *ngFor="let bplanBusiOperationsTypeD of bplanBusiOperationsTypeDropDown" [value]="bplanBusiOperationsTypeD">
                    {{ bplanBusiOperationsTypeD.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>-->
             </p>  
         <p>
              {{dataBplan?.bplanCustomerAppeal}}
        </p>
        <p>
             {{dataBplan?.bplanTeamSummary}}
       </p>
       <p>
          {{dataBplan?.bPlanMarketingSummary}} 
      </p>
        <!--  <a class="modal-click" (click)="modal.openOfferSentenceHelp()">
            <mat-icon class="matTooltip" matSuffix>info</mat-icon>
         </a> -->
       </div>
    </div>
    <div class="CompanyDescription">
    <div>
      <h3 class="results-headers"><b>1.1 Objectives</b></h3>
      The objectives for the next three years of operation include:
      <ol>
        <div>
          <div *ngFor="let x of dataBplan?.bplanLongTermGoals; let i=index">
            <li>{{dataBplan?.bplanLongTermGoals[i].bplanLongTermGoal}}</li>
            </div>
          </div>
        </ol>
    </div>
    <div>
      <h3 class="results-headers"><b>1.2 Mission</b></h3>
        {{dataBplan?.bPlanMission}} {{dataBplan?.bPlanMissionExpanded}}
    </div>
    <div>
      <h3 class="results-headers"><b>1.3 Keys to Success</b></h3>
      The keys to success are: {{dataBplan?.bplanKeysToSuccess}}
    </div>
  </div>
  <div class="CompanySummary">
    <div>
      <h3 class="results-headers"><b>2.1 Company Ownership</b></h3>
        {{dataBplan?.bplanBusiName}} is {{dataBplan?.bplanBusiRegStatus}} as {{dataBplan?.bplanBusiRegType?.name}} owned and operated by {{retrieveTeamNames('bPlanTeamFirstName')}}. 
    </div>
    <div>
        {{dataBplan?.bplanBusiName}} is a {{dataBplan?.bplanBusinessAge}} {{dataBplan?.bPlanIndustryType}} {{dataBplan?.bplanBusiType}} that serves {{dataBplan?.bplanCustomerPersonaSummary}}, 
        based in {{dataBplan?.bplanCustomerLocation}}. The {{dataBplan?.bplanBusiType}} will operate out of {{dataBplan?.bplanBusiOperationsType}}, with an address located at 
        {{dataBplan?.bplanBusiStreet}} {{dataBplan?.bplanBusiStreet2}} {{dataBplan?.bplanBusiCity}}, {{dataBplan?.bplanBusiState}} {{dataBplan?.bplanBusiZipcode}}.
    </div>
    <div>
      <h3 class="results-headers"><b>2.2 Startup Summary</b></h3>
        {{dataBplan?.bplanBusiName}} will incur the following start-up costs: 
        <p>Short Term Assets:</p>
        <p>Long Term Assets:</p>
    </div>
     </div>
     <div class="BusinessOffering">  
       <!--New Section-->
      <div>
        <h3 class="results-headers"><b>3 {{dataBplan?.bplanBusiName}}'s {{dataBplan?.bplanBusiOfferType}}s</b></h3>
          {{dataBplan?.bplanBusiName}} provides {{dataBplan?.bplanOfferSummary}} {{dataBplan?.bplanBusiOfferType}}s primarily to
          {{dataBplan?.bplanCustomerLocation}} {{dataBplan?.bplanCustomerPersonaSummary}}. Our {{dataBplan?.bplanBusiOfferType}} list is below:
          <table class="table table-bordered">
            <thead class="thead-dark">
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Price</th>
                <th>Price Type</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody *ngFor="let x of dataBplan?.bPlanOfferArray; let i=index">
              <tr>
                <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferName}}</td>
                <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferType}}</td>
                <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferPrice}}</td>
                <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferPriceType}}</td>
                <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferDescription}}</td>
              </tr>
            </tbody>
          </table>
          The price of our {{dataBplan?.bplanBusiOfferType}}s {{dataBplan?.bplanBusiOfferPriceDeterminant}}.
       {{dataBplan?.bPlanOfferingExpansion}}
      </div>
    </div>
    <div class="MarketAnalysis">
      <div>
        <!--New Section-->
        <h3 class="results-headers"><b>Market Analysis</b></h3>
        <!--New subsection-->
        <h3 class="results-headers"><b>4.1 Market Segmentation</b></h3>
        <p>{{dataBplan?.bPlanMarketDescription}}</p>
        <!--New subsection-->
        <h3 class="results-headers"><b>4.2 Target Market Segment Strategy</b></h3>
        We target our market segments through a number of different ways.
        <p>{{dataBplan?.bPlanMarketTargetSummary}}</p>
        <!--New subsection-->
        <h3 class="results-headers"><b>4.3 Industry Analysis</b></h3>
        <p>{{dataBplan?.bPlanIndustryAnalysis}}</p>
         <!--New subsection-->
         <h3 class="results-headers"><b>4.4 Competition</b></h3>
         The following are the main {{dataBplan?.bplanOfferSummary}} {{dataBplan?.bplanBusiOfferType}}s that we think
         are our main competitors:
         <p>{{dataBplan?.bPlanCompetitionDescription}}</p>
      </div>
    </div>
    <div class="StrategyandImplementationSummary ">
      <div>
        <!--New Section-->
        <h3 class="results-headers"><b>Strategy and Implementation Summary </b></h3>
        <!--intro summary-->
        <p>{{dataBplan?.bplanBusiName}} marketing and sales strategy utilizes many methods to develop 
          visibility for the company.</p>
        <!--New subsection-->
        <h3 class="results-headers"><b>5.1 Marketing Strategy </b></h3>
        As noted previously in the ‘Target Market Segment Strategy’ Section, we rely on multiple activities for our marketing efforts.
        These include:
        <ol>
          <div>
            <div *ngFor="let x of dataBplan?.bplanBusiMarketStrategy; let i=index">
              <li>{{dataBplan?.bplanBusiMarketStrategy[i]}}</li>
              </div>
            </div>
          </ol>
        <p>{{dataBplan?.bplanBusiMarketStrategyDescription}}</p>
        <!--New subsection-->
        <h3 class="results-headers"><b>5.2 Sales Strategy</b></h3>
        <p> {{dataBplan?.bPlanBusiSalesStrategyDescription}}</p>
         <!--New subsection-->
         <h3 class="results-headers"><b>5.3 Sales Forecast</b></h3>
         <p>{{dataBplan?.bplanBusiName}} {{dataBplan?.bplanCustomerStatus}}. {{dataBplan?.bPlanBusiSalesForecastDescription}}</p>

         <!--New subsection-->
        <h3 class="results-headers"><b>5.4 Milestones</b></h3>
        <p>{{dataBplan?.bplanBusiName}}'s short-term goals for the first year of operations are as follows:</p>
        <ol>
          <div>
            <div *ngFor="let x of dataBplan?.bplanShortTermGoals; let i=index">
              <li>{{dataBplan?.bplanShortTermGoals[i].bplanShortTermGoal}}</li>
              </div>
            </div>
          </ol>
      <!--New subsection-->
      <h3 class="results-headers"><b>5.5 Competitve Edge</b></h3>
      <p>{{dataBplan?.bplanDifferentiationList}} {{dataBplan?.bPlanDifferentiationExpansion}}  
       </p>
      </div>
    </div>
    <div class="ManagementSummary ">
      <div>
        <!--New Section-->
        <h3 class="results-headers"><b>Management Summary </b></h3>
        <ol>
          <div>
            <div *ngFor="let x of dataBplan?.bplanTeamNames; let i=index">
              <li>{{dataBplan?.bplanTeamNames[i].bPlanTeamFirstName}} {{dataBplan?.bplanTeamNames[i].bPlanTeamLastName}}: {{dataBplan?.bplanTeamNames[i].bPlanTeamMemberDescription}} </li>
              </div>
            </div>
          </ol>
        <!--New subsection-->
      <h3 class="results-headers"><b>6.1 Personnel Plan</b></h3>
      <p>{{dataBplan?.bplanPersonnelPlan}}</p>
    </div>
    </div>
    <div class="Financial Projections ">
      <div>
        <!--New Section-->
        <h3 class="results-headers"><b>Financial Projections </b></h3>
      </div>
    </div>
</div>

</div>
</div>
</div>
<!--END BUSINESS PLAN-->
<!--START STEPPER-->
<div class="col-6">
  <!--<button mat-raised-button (click)="isLinear = !isLinear" id="toggle-linear">
    {{!isLinear ? 'Enable linear mode' : 'Disable linear mode'}}
  </button>-->
  <mat-vertical-stepper orientation="vertical" [linear]="isLinear" #stepper>
    <mat-step [stepControl]="firstFormGroup">
      <form *ngIf="firstFormGroup" [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
        <ng-template matStepLabel>The Basics</ng-template>
       <div class="row">
        <div class = "col"> 
        <mat-form-field appearance="fill">
          <mat-label>Business Name</mat-label>
          <input matInput placeholder="Ex. KH Photographix"  [ngModel]="dataBplan?.bplanBusiName" formControlName="bplanBusiName" required>
        </mat-form-field>
        </div> 
        <div class = "col">
        <mat-form-field appearance="fill">
          <mat-label>Business Street Address</mat-label>
          <input matInput placeholder="Ex. 123 Main St."  [ngModel]="dataBplan?.bplanBusiStreet"  formControlName="bplanBusiStreet" required>
        </mat-form-field>
      </div>
      </div>
      <div class="row"> 
        <div class = "col">
          <mat-form-field appearance="fill">
            <mat-label>Business Street Address 2</mat-label>
            <input matInput placeholder="Ex. Suite 300"  [ngModel]="dataBplan?.bplanBusiStreet2" formControlName="bplanBusiStreet2">
          </mat-form-field>
        </div>
      <div class = "col">
        <mat-form-field appearance="fill">
          <mat-label>Business City</mat-label>
          <input matInput placeholder="Ex. Pittsburgh"  [ngModel]="dataBplan?.bplanBusiCity"  formControlName="bplanBusiCity" required>
        </mat-form-field>
      </div>
      </div>
      <div class = "row">
        <div class = "col">
          <mat-form-field class="full-width">
            <mat-select placeholder="State"  [ngModel]="dataBplan?.bplanBusiState"  formControlName="bplanBusiState">
              <mat-option *ngFor="let state of states" [value]="state.abbreviation">
                {{ state.name }}
              </mat-option>
            </mat-select>
           <!-- <mat-error *ngIf="assessmentForm.controls['bplanBusiState'].hasError('required')">
              State is
            </mat-error>-->
          </mat-form-field>
        </div>
      <div class = "col">
        <mat-form-field appearance="fill">
          <mat-label>Business Zipcode</mat-label>
          <input matInput placeholder="Ex. 12345"  [ngModel]="dataBplan?.bplanBusiZipcode"  formControlName="bplanBusiZipcode" required>
        </mat-form-field>
      </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <mat-label>What are you offering?</mat-label>
            <mat-select   [ngModel]="dataBplan?.bplanBusiOfferType" formControlName="bplanBusiOfferType">
              <mat-option *ngFor="let bplanBusiOfferTypeD of bplanBusiOfferTypeDropDown" [value]="bplanBusiOfferTypeD.name">
                {{ bplanBusiOfferTypeD.name }}
              </mat-option>
            </mat-select>
           <!-- <mat-error *ngIf="assessmentForm.controls['bplanBusiType'].hasError('required')">
              State is
            </mat-error>-->
          </mat-form-field>
        </div>
        <div class = "col">
          <mat-form-field class="full-width">
            <mat-label>What would you refer to your business as?</mat-label>
            <mat-select  [ngModel]="dataBplan?.bplanBusiType" formControlName="bplanBusiType">
              <mat-option *ngFor="let bplanBusiTypeD of bplanBusiTypeDropDown" [value]="bplanBusiTypeD.name">
                {{ bplanBusiTypeD.name }}
              </mat-option>
            </mat-select>
           <!-- <mat-error *ngIf="assessmentForm.controls['bplanBusiType'].hasError('required')">
              State is
            </mat-error>-->
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <button class="block" mat-raised-button color="primary" type="submit" matStepperNext>Save</button>
      </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="ExecutiveSummaryFormGroup">
      <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()" >
        <ng-template matStepLabel>Executive Summary</ng-template>
        
        <div class="row">
          <div class="col">
        <mat-form-field class="full-width">
          <mat-label>What is your service or product in 7 words or less? 
          </mat-label>
          <input matInput placeholder="ex. multimedia, graphic design and visual communications" [ngModel]="dataBplan?.bplanOfferSummary" formControlName="bplanOfferSummary" required>
        </mat-form-field>
        </div>
        </div>
        <div class="row">
          <div class="col">
        <mat-form-field class="full-width">
          <mat-label>Who is your target customer in 4 words or less? 
          </mat-label>
          <mat-icon class="matTooltip" matSuffix
            matTooltip="Refer to your Assessment Customer Persona Section">
            info</mat-icon>
          <input matInput placeholder="ex. medium to large businesses" [ngModel]="dataBplan?.bplanCustomerPersonaSummary" formControlName="bplanCustomerPersonaSummary" required>
        </mat-form-field>
        </div>
        </div>
        <div class="row">
          <div class="col">
        <mat-form-field class="full-width">
          <mat-label>Where are your customers in location? </mat-label>
          <input matInput placeholder="Ex. Western, PA, or the USA, or Harvard"  [ngModel]="dataBplan?.bplanCustomerLocation" formControlName="bplanCustomerLocation" required>
        </mat-form-field>
        </div>
        </div>
      <!--  <mat-form-field class="full-width" appearance="fill">
          <mat-label>Finish the sentence</mat-label>
          <input matInput placeholder="Ex. Pizza" value="{{this.data?.bplanBusiName}} name will operate out of a _____">
        </mat-form-field>-->
        <div class = "row">
       <div class = "col">  
        <mat-form-field >
          <mat-label>Where will you operate? </mat-label>
          <mat-icon class="matTooltip" matSuffix
          matTooltip="Retail location can be store, food truck, etc.">
          info</mat-icon>
          <mat-select [ngModel]="dataBplan?.bplanBusiOperationsType"  formControlName="bplanBusiOperationsType">
            <mat-option *ngFor="let bplanBusiOperationsTypeD of bplanBusiOperationsTypeDropDown" [value]="bplanBusiOperationsTypeD.name">
              {{ bplanBusiOperationsTypeD.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>  
      <div class = "col">  
      <button class="block" mat-raised-button color="primary">Save</button>
      </div>
    </div>
    </form>
      <!--  <label>0A. Finish the sentence and insert a personable characteristic of your customer. <br>
          <em>Ex. The target customer is businesses who [tend to not have a brand identity].</em>  
        </label>-->
    <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
      <div class="row pt-3">
        <div class="col">
          <label>Insert a sentence about a personable characteristic of your customer. 
            <br>Ex. The target customer is businesses who tend to not have a brand identity.
          </label>
           <mat-form-field  class="full-width" appearance="fill">
          <input matInput  [ngModel]="dataBplan?.bPlanCustomerCharacterstic"  formControlName="bPlanCustomerCharacterstic" >
        </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class ="col">
        <mat-form-field class="full-width">
          <mat-label>In one sentence, how will you appeal to your customer? </mat-label>
          <input matInput [ngModel]="dataBplan?.bplanCustomerAppeal"  placeholder="Ex. [Business name] will produce unique ..." formControlName="bplanCustomerAppeal" required>
          <mat-icon class="matTooltip" matSuffix
            matTooltip="Ex. KH Photographix will offer companies unique and fresh designs for their corporate identity and visual communication.">
            info</mat-icon>
        </mat-form-field>
      </div>
      </div>
      <div class="row">
      <div class ="col">
        <label>Insert 3 sentences about the owner(s). 
          <ol>
           <li>Highlight a strong skill of the owner that makes them the right person to run the business. </li>
           <li>Summarize the role that they play in the business. </li>
           <li>Combine the role the owner plays and the competitive advantage of the business.</li>
          </ol>
           If you took a model assessment, you can get ideas from your assessment Differentiation Section. 
           </label>
        <mat-form-field class="full-width" appearance="fill">
          <textarea matInput
          [ngModel]="dataBplan?.bplanTeamSummary" 
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5" formControlName="bplanTeamSummary"></textarea>
          <mat-icon class="matTooltip" matSuffix
          matTooltip="Ex. 1) Dre is skilled in client interactions and brings a fresh perspective 
          on design and creativity. 2) Dre interacts with clients from start to finish, bringing 
          their ideas to life and making them apart of the ‘Boss’ Design Journey. 3) When clients 
          connect with a person, rather solely the business itself, the projects are more successful
           and KH Photographix’s not only gains a competitive edge, but duly taps into the power of 
           ‘word of mouth marketing’.   ">
          info</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="row pt-3"><!DOCTYPE html>
      <div class="col">
        <label>Finish the sentence and summarize how you will get customers.
          <br>Ex. KH Photographix will grow their customer base through word of mouth and good customer service. 
        </label>
         <mat-form-field  class="full-width" appearance="fill">
        <input matInput [ngModel]="dataBplan?.bPlanMarketingSummary"  formControlName="bPlanMarketingSummary" >
      </mat-form-field>
      </div>
    </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button type="submit" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step> 
    <mat-step [stepControl]="CompanyDescriptionFormGroup">
    <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
      <ng-template matStepLabel>Company Description</ng-template>
      <label class="sub-title pt-3">1.1 Objectives</label>
      <div class="row">
        <div class="col">
          <label>Insert high level goals for your next 3 years. Include metrics where possible. </label>
          
          <div *ngFor="let ltGoal of dataBplan?.bplanLongTermGoals; let i=index">
            <div *ngIf="dataBplan?.bplanLongTermGoals[i]?.bplanLongTermGoal != null">
              <li>{{i+1}} : {{dataBplan?.bplanLongTermGoals[i]?.bplanLongTermGoal}} 
              <!-- <button (click)="removeLongTermGoal(i)" class="btn btn-danger">Remove</button></li> -->
            </div>
            
          </div>
          <div formArrayName="bplanLongTermGoals">

            <div>
              <button (click)="addLongTermGoal(true)" class="btn" mat-raised-button color="primary">Add Long Term Goal</button>
              <button (click)="editLongTermGoal()" class="btn" mat-raised-button color="primary">Edit Long Term Goal</button>
            </div>
            
            <div *ngFor="let ltGoal of longTermGoals()?.controls; let x = index" [formGroupName]="x">
              <div *ngIf="longTermInit==false">
                <div *ngIf="dataBplan?.bplanLongTermGoals[x]?.bplanLongTermGoal != null">
                  <mat-form-field  class="full-width">
                  <input  [ngModel]="dataBplan?.bplanLongTermGoals[x]?.bplanLongTermGoal"   
                  matInput 
                  placeholder="Ex. KH Photographix goal is to gain 30 customers by Year 1 to move into a retail location." 
                  formControlName="bplanLongTermGoal" required>
                </mat-form-field>
                </div>
                
                <div>
                  <button (click)="removeLongTermGoal(x)" class="btn btn-danger">Remove</button>
                   <button class="btn"  mat-button color="grey">Update</button>
                </div>
              </div>
              <div *ngIf="longTermInit==true">
                <div *ngIf="dataBplan?.bplanLongTermGoals[x]?.bplanLongTermGoal == null">
                  <mat-form-field  class="full-width">
                    <input  
                    [ngModel]="dataBplan?.bplanLongTermGoals[x]?.bplanLongTermGoal"   
                    matInput 
                    placeholder="Ex. KH Photographix goal is to gain 30 customers by Year 1 to move into a retail location." 
                    formControlName="bplanLongTermGoal" >
                  </mat-form-field>
                  <div>
                    <button (click)="removeLongTermGoal(x)" class="btn btn-danger">Remove</button>
                     <button class="btn" (click)="addLongTermGoal(false)"   mat-button color="grey">Save</button>
                  </div>

                </div>
             
              </div>
              
              
          </div>
          
          </div>

        </div>
      </div>
      <label class="sub-title pt-3">1.2 Mission</label>
      <div class="row pt-3">
        <div class="col">
          <label>Finish the sentence and insert your mission statement. 
            <br> Need help? Use this template format and reformat as seen in the info example:
            <br>We [provide this value] to [target customers] by [what you do] through [how you do it].  
            <mat-icon class="matTooltip" matSuffix
            matTooltip=" Ex. KH Photographix's mission is to provide small-businesses [target customers] with creative multi-media deliverables [provide this value], by creating ‘Boss Designs’ [how you do it]. ">
            info</mat-icon>
          </label>
           <mat-form-field  class="full-width" appearance="fill">
          <input [ngModel]="dataBplan?.bPlanMission"   matInput formControlName="bPlanMission" />
        </mat-form-field>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col">
          <label>Then expand on your mission statement in 2-3 sentences.Need help? Use this template format and 
            reformat as seen in the info example:
            <br> Sentence 1: What you do
            <br> Sentence 2: Who you do it for 
            <br> Sentence 3: How/why you do it. 
            <mat-icon class="matTooltip" matSuffix
            matTooltip=" Ex. We empower our client’s brands [who you do it for], by boosting their confidence in their 
            business’ ability to effectively reach their ideal customer [what you do]. We have a passion for creating 
            new opportunities for our clients [why you do it]. ">
            info</mat-icon>
          </label>
           <mat-form-field  class="full-width" appearance="fill">
            <textarea matInput
            [ngModel]="dataBplan?.bPlanMissionExpanded" 
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5" formControlName="bPlanMissionExpanded"></textarea>
        </mat-form-field>
        </div>
      </div>
      <label class="sub-title">1.3 Keys to Success</label>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <mat-label>List 3-4 adjectives that will help your business succeed.  </mat-label>
            <input 
            [ngModel]="dataBplan?.bplanKeysToSuccess" 
            matInput placeholder="Ex. Creativity, Personal touch, Customer experience, Trust " formControlName="bplanKeysToSuccess" required>
          </mat-form-field>
        </div>
      </div>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button type="submit" matStepperNext>Next</button>
      </div>
    </form>
   </mat-step>
   <mat-step [stepControl]="CompanySummaryFormGroup">
    <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
      <ng-template matStepLabel>Company Summary</ng-template>
      <div class="row">
        <div class = "col">  
          <mat-form-field >
            <mat-label>What industry are you in? </mat-label>
            <mat-select [ngModel]="dataBplan?.bPlanIndustryType"  formControlName="bPlanIndustryType">
              <mat-option *ngFor="let bPlanIndustryTypeD of bPlanIndustryTypeDropDown" [value]="bPlanIndustryTypeD.name">
                {{ bPlanIndustryTypeD.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>  
        <div class="col">
          <mat-form-field class="full-width">
            <mat-label>How old is your business? </mat-label>
            <input
            [ngModel]="dataBplan?.bplanBusinessAge"  
            matInput placeholder="Ex. 9 month old or not yet registered" formControlName="bplanBusinessAge" required>
          </mat-form-field>
          </div>
      </div>
      <label class="sub-title">2.1 Company Ownership</label>
      <div class="row">
        <div class="col">
            <mat-form-field class="full-width">
              <mat-label>Select one. My business...</mat-label>
              <mat-select 
              [ngModel]="dataBplan?.bplanBusiRegStatus"  
              formControlName="bplanBusiRegStatus">
                <mat-option *ngFor="let bplanBusiRegStatusD of bplanBusiRegStatusDropDown" [value]="bplanBusiRegStatusD.name">
                  {{ bplanBusiRegStatusD.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="full-width">
            <mat-label>Select one. My business will (or is) register as...</mat-label>
            <mat-select 
            [ngModel]="dataBplan?.bplanBusiRegType"  
            formControlName="bplanBusiRegType">
              <mat-option *ngFor="let bplanBusiRegTypeD of bplanBusiRegTypeDropDown" [value]="bplanBusiRegTypeD.name">
                {{ bplanBusiRegTypeD.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      </div>
      <div>
      <label class="sub-title">2.2 Start-up Summary</label>
      <div class="row pt-3">
          <p class="comeBack">After download, insert your startup costs once you have your financial projections.
          </p>
      </div>
    </div>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button type="submit" matStepperNext>Next</button>
      </div>
    </form>
    </mat-step>
    <mat-step [stepControl]="BusinessOfferingFormGroup">
      <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
        <ng-template matStepLabel>Business Offering</ng-template>
        <label class="sub-title pt-3">Products and Services</label>
        <div class="row">
          <div class="col">
            <table class="table table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Price</th>
                  <th>Price Type</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody *ngFor="let x of dataBplan?.bPlanOfferArray; let i=index">
                <tr>
                  <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferName}}</td>
                  <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferType}}</td>
                  <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferPrice}}</td>
                  <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferPriceType}}</td>
                  <td>{{dataBplan?.bPlanOfferArray[i].bplanOfferDescription}}</td>
                </tr>
              </tbody>
            </table>
            <div formArrayName="bPlanOfferArray">
              <div>
                <button (click)="addOffer(true)" class="btn" mat-raised-button color="primary">Add Product or Service</button>
                <button (click)="editOffer()" class="btn" mat-raised-button color="primary">Edit Product or Service</button>

              </div>

              
              <div *ngFor="let offer of getOfferArray().controls; let i=index" [formGroupName]="i">
                <div *ngIf="offerInit == true">
                  <div *ngIf="dataBplan?.bPlanOfferArray[i].bplanOfferName==null || dataBplan?.bPlanOfferArray[i].bplanOfferPrice==null || dataBplan?.bPlanOfferArray[i].bplanOfferDescription==null">
                    <mat-form-field class="full-width">
                      <input 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferName" 
                      matInput placeholder="Offer Name" formControlName="bplanOfferName" >
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-select 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferType" 
                      formControlName="bplanOfferType">
                        <mat-option *ngFor="let bplanOfferTypeD of bplanOfferTypeDropDown" [value]="bplanOfferTypeD">
                          {{ bplanOfferTypeD}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <input 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferPrice" 
                      matInput placeholder="Offer Price ($4.99)" formControlName="bplanOfferPrice" >
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-select 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferPriceType" 
                      formControlName="bplanOfferPriceType">
                        <mat-option *ngFor="let bplanOfferPriceTypeD of bplanOfferPriceTypeDropDown" [value]="bplanOfferPriceTypeD">
                          {{ bplanOfferPriceTypeD}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <input 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferDescription" 
                      matInput placeholder="Offer Description" formControlName="bplanOfferDescription" >
                    </mat-form-field>
                    <button (click)="removeOffer(i)" class="btn btn-danger">Remove</button>
                    <button class="btn"  (click)="addOffer(false)" mat-raised-button color="primary">Save</button>
                  </div>
                </div>
                <div *ngIf="offerInit == false">
                  <div *ngIf="dataBplan?.bPlanOfferArray[i]?.bplanOfferName!=null && dataBplan?.bPlanOfferArray[i]?.bplanOfferPrice!=null && dataBplan?.bPlanOfferArray[i]?.bplanOfferDescription!=null">
                    <mat-form-field class="full-width">
                      <input 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferName" 
                      matInput placeholder="Offer Name" formControlName="bplanOfferName" required>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-select 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferType" 
                      formControlName="bplanOfferType">
                        <mat-option *ngFor="let bplanOfferTypeD of bplanOfferTypeDropDown" [value]="bplanOfferTypeD">
                          {{ bplanOfferTypeD}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <input 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferPrice" 
                      matInput placeholder="Offer Price ($4.99)" formControlName="bplanOfferPrice" required>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-select 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferPriceType" 
                      formControlName="bplanOfferPriceType">
                        <mat-option *ngFor="let bplanOfferPriceTypeD of bplanOfferPriceTypeDropDown" [value]="bplanOfferPriceTypeD">
                          {{ bplanOfferPriceTypeD}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <input 
                      [ngModel]="dataBplan?.bPlanOfferArray[i]?.bplanOfferDescription" 
                      matInput placeholder="Offer Description" formControlName="bplanOfferDescription" required>
                    </mat-form-field>
                    <button (click)="removeOffer(i)" class="btn btn-danger">Remove</button>
                   
                      <button class="btn"   mat-raised-button color="primary">Update</button>
                  
                  </div>
                </div>
               
            </div>
           
            </div>
          </div>
        </div>
        <div class="row">
          <mat-form-field class="full-width">
            <mat-label>Finish the sentence. Our product or service prices...</mat-label>
            <mat-select 
            [ngModel]="dataBplan?.bplanBusiOfferPriceDeterminant" 
            formControlName="bplanBusiOfferPriceDeterminant">
              <mat-option *ngFor="let bplanBusiOfferPriceDeterminantD of bplanBusiOfferPriceDeterminantDropDown" [value]="bplanBusiOfferPriceDeterminantD.name">
                {{ bplanBusiOfferPriceDeterminantD.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row pt-3">
          <div class="col">
            <label>What else needs to be known about your product or services?  
              <mat-icon class="matTooltip" matSuffix
              matTooltip=" Ex. All services (except photography) will be
               developed in the home office and delivered virtually, unless requested otherwise by the client.">
              info</mat-icon>
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bPlanOfferingExpansion" 
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bPlanOfferingExpansion"></textarea>
          </mat-form-field>
          </div>
        </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button type="submit" matStepperNext>Next</button>
        </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="MarketingFormGroup">
      <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
        <ng-template matStepLabel>Marketing</ng-template>
        <label class="sub-title pt-3">4.1 Market Segmentation</label>
        <div class="row">
          <label>This section will be heavily informed by you knowing your industry, talking with
             your customers and doing research. It is important to take these steps to minimize the 
             risk of not having a paying customer. The better you know your customer (i.e. your market,
              the easier you will be able to write this section, and know how to create a product or 
              service that they will use). 
          </label>
        </div>
        <div class="sub-heading-3">Step 1: Identify what problem your business solves and for who</div>
        <div class="row explainer">
          <p> Good news, you did that above. You specified your target market is {{dataBplan?.bplanCustomerPersonaSummary}}, 
            based in {{dataBplan?.bplanCustomerLocation}}.
            Tip: If your market is too large, don't try to please everybody. The broader your target market is, the harder it will be to market and reach your customer.
          </p>
        </div>
        <div class="sub-heading-3">Step 2: <b>Divide your market into 2-4 large categories</b> via demographic, user groups <u><b>or</b></u> psychographic traits. </div>
        <div class="row explainer">
          <li>Ex. Demographic: 1) Small businesses in Eastern, PA and 2) large businesses in Western, PA.</li>
          <li>Ex. User Group: 1) Homeschool parents and 2) public-school teachers</li>
          <li>Ex. Psychographic: 1) Businesses who make decisions by committee and 2) businesses who make decisions by owner</li>
        </div>
        <div class="row pt-3">
          <div class="col">
            <label> Take notes below.
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bPlanMarketDemographicNotes" 
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bPlanMarketDemographicNotes"></textarea>
          </mat-form-field>
          </div>
        </div>
        <div class="sub-heading-3">Step 3: 🔎Research statistics about these categories as it relates to your business. And talk with potential customers about what they think about your product and/or service. </div>
          <div class="row pt-3">
          <div class="col">
            <label>Ex. Search: How much do {{dataBplan?.bplanCustomerPersonaSummary}} spend on {{dataBplan?.bplanOfferSummary}}. Take notes below.
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bPlanMarketResearchNotes" 
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bPlanMarketResearchNotes"></textarea>
          </mat-form-field>
          </div>
        </div>
        <div class="sub-heading-3">Step 4: <b>Write your findings below.</b></div>
        <div class="row explainer">
            Example Starting Sentence: For {{dataBplan?.bplanCustomerPersonaSummary}} who experience [problem they are running into], there is a need for [solution your business offers]. 
        </div>
        <div class="row pt-3">
          <div class="col">
            <label>In 3-5 sentences, prove the first 'Example Starting Sentence' using quotes, statistics, etc. 
              In the first 2-4 sentences, talk about your first target customer and their category.
               Then list how your product or service, and its characteristics, solves their problem
                in 1 sentence. Do this for each market segment.  
              <mat-icon class="matTooltip" matSuffix
              matTooltip=" Ex. For small businesses who don’t have a brand identity [the problem], 
              there is a need for graphic designer to help them out [solution]. We found that 50% of 
              small businesses don’t have a brand identity, yet 85% of customer’s trust is influenced 
              by a businesses’ brand. For medium businesses, brands are generally established, but 
              rebranding is usually a need. Etc. ">
              info</mat-icon>
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bPlanMarketDescription" 
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bPlanMarketDescription"></textarea>
          </mat-form-field>
          </div>
        </div>
        <div class="row">
          <button class="block " mat-raised-button color="primary">Save</button>
        </div>
      <label class="sub-title pt-3">4.2 Target Market Segment Strategy</label>
      <div class="row">
        <div class="col">
          <label>Add statistics here that support and relate to how you plan to 
            reach your market segment. 🔎<b>Research how to advertise to the segment, and document 
            how effective the advertisement is.</b> Summarize at least 2 different ways to reach your 
            customer, this will be expanded in the Marketing Strategy Section.  
            <mat-icon class="matTooltip" matSuffix
            matTooltip="Ex. Of our target customer base, 87% of small business owners are on 
            LinkedIn. 90% of those in Western, PA use Facebook. Therefore, our market strategy 
            will use Facebook and LinkedIn to reach our target customer. ">
            info</mat-icon>
          </label>
           <mat-form-field  class="full-width" appearance="fill">
            <textarea matInput
            [ngModel]="dataBplan?.bPlanMarketTargetSummary"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5" formControlName="bPlanMarketTargetSummary"></textarea>
        </mat-form-field>
        </div>
      </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button type="submit" matStepperNext>Next</button>
        </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="IndustryFormGroup">
      <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
        <ng-template matStepLabel>Industry</ng-template>
        <label class="sub-title pt-3">4.3 Industry Analysis</label>
        <div class="row pt-3">
          <div class="col">
            <label>This section of the business plan should highlight the {{dataBplan?.bPlanIndustryType}} 
              industry.  🔎<b>Research</b>: What is the growth rate of the industry? What trends is the 
              industry seeing? How are suppliers responding to industry changes? What new technology 
              is in the industry? If you have in depth industry knowledge, document what you already know 
              and find statistics to back it up. You can also refer to the Offer Section in your assessment.  
              <mat-icon class="matTooltip" matSuffix
              matTooltip="Ex. The graphics industry is moving towards flat designs. As design generally follows
               trends, KH Photographix has modified its portfolio to reflect flat design. The industry is also
                moving towards Apple products and Adobe to produce content. Industry suppliers are beginning to
                raise costs. ">
              info</mat-icon>
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bPlanIndustryAnalysis"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bPlanIndustryAnalysis"></textarea>
          </mat-form-field>
          </div>
        </div>
        <label class="sub-title pt-3">4.4 Competition</label>
        <div class="row pt-3">
          <div class="col">
            <label>List 3-4 competitors in your industry. Everyone has competitors, the competitor 
              to the car, was the horse. Find some potential competitors and list each one’s services
              in 2-3 sentences below.  🔎Research: What are their product or services and prices?
               Where are they located? Read their reviews to see what they do well and what they don’t. 
               Go to their About Page to find more information.  
              <mat-icon class="matTooltip" matSuffix
              matTooltip="•	Ex. Competitor 1: Kris Agency provides digital design services to small 
              businesses in Aliquippa, PA. They have a team of 5 people who span photography to web 
              development. They have been operating for 2 years and have a large online presence.">
              info</mat-icon>
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bPlanCompetitionDescription"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bPlanCompetitionDescription"></textarea>
          </mat-form-field>
          </div>
        </div>
        <div class="row explainer">
          This section should focus on how your competitors are competitive to you, so you don’t have 
          to defend your business here. This will be expanded on in the Competitive Edge Section.
        </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button type="submit" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="StrategyFormGroup">
      <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
        <ng-template matStepLabel>Strategy and Implementation </ng-template>
        <label class="sub-title pt-3">5.1 Marketing Strategy</label>
        <div class="row">
          <mat-form-field class="full-width">
            <label>List the 2 different ways that you plan to reach your customer 
              that you listed in the ‘Target Market Segment Strategy’ Section. You can 
              also choose from the list below. Then expand on how you will implement each strategy. 
            </label>
            <mat-select 
            [ngModel]="dataBplan?.bplanBusiMarketStrategy"
            formControlName="bplanBusiMarketStrategy" multiple>
              <mat-option *ngFor="let bplanBusiMarketStrategyD of bplanBusiMarketStrategyDropDown" [value]="bplanBusiMarketStrategyD.name" >
                {{ bplanBusiMarketStrategyD.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row pt-3">
          <div class="col">
            <label>Expand on your list here, if desired.
              <mat-icon class="matTooltip" matSuffix
              matTooltip="Ex. Outreach - We will reach out to 10 clients per month via LinkedIn">
              info</mat-icon>
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bplanBusiMarketStrategyDescription"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bplanBusiMarketStrategyDescription"></textarea>
          </mat-form-field>
          </div>
          </div>
        <label class="sub-title pt-3">5.2 Sales Strategy</label>
        <div class="row pt-3">
          <div class="col">
            <label>Finish the sentence on how you plan to sell. Is it through a website, proposals, portfolios, in person 
              stands? What point of sale system will you use, will you invoice customers or accept credit cards? Mention 
              those things here.
              <mat-icon class="matTooltip" matSuffix
              matTooltip="Ex. KH Photographix will utilize portfolios to showcase our work, and respond to “Call for Proposals” 
              and inquiries on our website for services. We will then follow up with our customers to provide them with a quote. 
              We will invoice the customer as milestones are completed with 30 day payment windows.">
              info</mat-icon>
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bPlanBusiSalesStrategyDescription"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bPlanBusiSalesStrategyDescription"></textarea>
          </mat-form-field>
          </div>
        </div>
        <label class="sub-title pt-3">5.3 Sales Forecast</label>
        <div class="row pt-3">
          <mat-form-field class="full-width">
            <mat-label>Finish the sentence. Our business...</mat-label>
            <mat-select [ngModel]="dataBplan?.bplanCustomerStatus"  formControlName="bplanCustomerStatus">
              <mat-option *ngFor="let bplanCustomerStatusD of bplanCustomerStatusDropDown" [value]="bplanCustomerStatusD.name" >
                {{ bplanCustomerStatusD.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row pt-3">
          <div class="col">
            <label>State your sales forecast statement, then explain your sales forecast and how you got to those numbers. 
                <mat-icon class="matTooltip" matSuffix
              matTooltip="If you’re a new business without customers: Ex. We’re forecasted to sell 
              100 products by year’s end. In our research, we found that purchase our product once a month, so this is reflected in our sales forecast. 
              If you’re an existing business with customers: Ex. We’ve provided over 100 customers with 
              graphic design services since 2019.  We see an uptake in sales during the months of Jan-May, which is reflected in our forecast. 
             ">
              info</mat-icon>
            </label>
             <mat-form-field  class="full-width" appearance="fill">
              <textarea matInput
              [ngModel]="dataBplan?.bPlanBusiSalesForecastDescription"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5" formControlName="bPlanBusiSalesForecastDescription"></textarea>
          </mat-form-field>
          </div>
        </div>
        <label class="sub-title pt-3">5.4 Milestones</label>
        <div class="row">
          <div class="col">
            <label>List your short-term goals that you want to achieve within the duration you set. 
               Make sure to reflect these goals and the cost to achieve them in your financials. 
            </label>
            <div *ngFor="let x of dataBplan?.bplanShortTermGoals; let i=index">
              <div  *ngIf="dataBplan?.bplanShortTermGoals[i]?.bplanShortTermGoal != null">
                    <li>{{dataBplan?.bplanShortTermGoals[i].bplanShortTermGoal}}</li>
              </div>
            </div>
            <div formArrayName="bplanShortTermGoals">
              <div>
                <button (click)="addShortTermGoal(true)" class="btn" mat-raised-button color="primary">Add Short Term Goal</button>
                <button (click)="editShortTermGoal()" class="btn" mat-raised-button color="primary">edit Short Term Goal</button>

              </div>
            
              <div *ngFor="let stGoal of shortTermGoals()?.controls; let x = index" [formGroupName]="x">
                  <!-- @leonkoech clean this -->
              <div *ngIf="shortTermGoalsInit == false && dataBplan?.bplanShortTermGoals[x]?.bplanShortTermGoal != null">
                <mat-form-field class="full-width">
                  <input 
                  [ngModel]="dataBplan?.bplanShortTermGoals[x]?.bplanShortTermGoal" 
                  matInput placeholder="Ex. We would like to move into an office space in downtown Pittsburgh. " formControlName="bplanShortTermGoal" required>
                </mat-form-field>
                <button (click)="removeShortTermGoal(x)" class="btn btn-danger">Remove</button>
                <button class="btn" mat-raised-button color="primary">update</button>              
              </div>
              <div *ngIf="shortTermGoalsInit == true && dataBplan?.bplanShortTermGoals[x]?.bplanShortTermGoal == null">
                <mat-form-field class="full-width">
                  <input 
                  [ngModel]="dataBplan?.bplanShortTermGoals[x]?.bplanShortTermGoal" 
                  matInput placeholder="Ex. We would like to move into an office space in downtown Pittsburgh. " formControlName="bplanShortTermGoal">
                </mat-form-field>
                <button (click)="removeShortTermGoal(x)" class="btn btn-danger">Remove</button>
                <button class="btn " (click)="addShortTermGoal(false)" mat-raised-button color="primary">save</button>              
              </div>
            </div>
            
            </div>
          </div>
        </div>
        <div class="row pt-3">
          <mat-form-field class="full-width">
            <mat-label>Finish the sentence. We want to achieve these short-term goals within the first...</mat-label>
            <mat-select 
            [ngModel]="dataBplan?.bplanMilestoneTimeline"
            formControlName="bplanMilestoneTimeline">
              <mat-option *ngFor="let bplanMilestoneTimelineD of bplanMilestoneTimelineDropDown" [value]="bplanMilestoneTimelineD.name" >
                {{ bplanMilestoneTimelineD.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <label class="sub-title pt-3">5.5 Competitve Edge</label>
        <div class="col">
          <mat-form-field class="full-width">
            <mat-label>Simply state how you are different here. Finish the sentence: Your business prides itself on </mat-label>
            <input 
            [ngModel]="dataBplan?.bplanDifferentiationList"
            matInput placeholder="Ex. our quality and inexpensive prices" formControlName="bplanDifferentiationList" required>
            <mat-icon class="matTooltip" matSuffix
            matTooltip=" Refer back to your ‘Competition Section’ to determine their features and state how you are different. ">
            info</mat-icon>
          </mat-form-field>
        </div>
          <div class="row pt-3">
              <label>Expand on how {{dataBplan?.bplanBusiName}} is different.  
                <mat-icon class="matTooltip" matSuffix
                matTooltip=" You can also refer to your ‘Differentiation Section’ in your assessment to identify the qualities. ">
                info</mat-icon>
              </label>
               <mat-form-field  class="full-width" appearance="fill">
                <textarea matInput
                [ngModel]="dataBplan?.bPlanDifferentiationExpansion"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5" formControlName="bPlanDifferentiationExpansion"></textarea>
            </mat-form-field>
          </div>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button type="submit" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="ManagementFormGroup">
      <form [formGroup]="firstFormGroup" novalidate (ngSubmit)="update()">
        <ng-template matStepLabel>Management Summary </ng-template>
        <div class="row explainer">
          Add your team members and their biographies. For each member, outline 
          their educational background (if applicable), the skills each one 
          brings to the business, their role in the business, their background 
          and how they relate to the business mission. <em>Ex: Dre Harris graduated from USC in 2019 with a degree in graphic communications. He leads client design on the team, etc.</em>
        </div>
        <div class="row">
          <div class="col">
            <div *ngFor="let x of dataBplan?.bplanTeamNames; let i=index">
              <div *ngIf="dataBplan?.bplanTeamNames[i]?.bPlanTeamFirstName != null || dataBplan?.bplanTeamNames[i]?.bPlanTeamLastName != null">
                <li>{{dataBplan?.bplanTeamNames[i]?.bPlanTeamFirstName}} {{dataBplan?.bplanTeamNames[i]?.bPlanTeamLastName}}: {{dataBplan?.bplanTeamNames[i]?.bPlanTeamMemberDescription}} 
                <button (click)="removeTeamName(i)" class="btn btn-danger">Remove</button></li>
              </div>
              
            </div>
            <div formArrayName="bplanTeamNames">
              <div>
                <button   (click)="editTeamName()"  mat-raised-button color="primary">Format Team Members</button>
                <button   (click)="addTeamName(true)"  mat-raised-button color="primary">Add New Team Member</button>
              
              </div>
              
              <div *ngFor="let teamName of teamNames().controls; let i=index" [formGroupName]="i">
                <div *ngIf="teaminit == true">
                  <!-- display null only -->
                  <div  *ngIf="dataBplan?.bplanTeamNames[i]?.bPlanTeamFirstName == null || dataBplan?.bplanTeamNames[i]?.bPlanTeamLastName == null">
                    <mat-form-field class="full-width">
                      <input [ngModel]="dataBplan?.bplanTeamNames[i]?.bPlanTeamFirstName" matInput placeholder="First Name" formControlName="bPlanTeamFirstName" >
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <input [ngModel]="dataBplan?.bplanTeamNames[i]?.bPlanTeamLastName" matInput placeholder="Last Name" formControlName="bPlanTeamLastName" >
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <textarea matInput placeholder="Description"
                      [ngModel]="dataBplan?.bplanTeamNames[i]?.bPlanTeamMemberDescription"
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="5" formControlName="bPlanTeamMemberDescription"></textarea>
                    </mat-form-field>
                    <button *ngIf="teaminit == true" (click)="addTeamName(false)"   mat-button color="blue">Save</button>
                    <button (click)="disregardTeamName(i)" class="btn btn-danger">Disregard</button>
                  </div>
                 
                </div>
                <div *ngIf="teaminit == false">
                  <!-- disply non null -->
                  <div  *ngIf="dataBplan?.bplanTeamNames[i]?.bPlanTeamFirstName != null || dataBplan?.bplanTeamNames[i]?.bPlanTeamLastName != null">
                    <mat-form-field class="full-width">
                      <input [ngModel]="dataBplan?.bplanTeamNames[i]?.bPlanTeamFirstName" matInput placeholder="First Name" formControlName="bPlanTeamFirstName" required>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <input [ngModel]="dataBplan?.bplanTeamNames[i]?.bPlanTeamLastName" matInput placeholder="Last Name" formControlName="bPlanTeamLastName" required>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <textarea matInput placeholder="Description"
                      [ngModel]="dataBplan?.bplanTeamNames[i]?.bPlanTeamMemberDescription"
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="5" formControlName="bPlanTeamMemberDescription"></textarea>
                    </mat-form-field>
                    <button (click)="removeTeamName(i)" class="btn btn-danger">Remove</button>
                  </div>
              </div>
               
                
            </div>
            </div>
          </div>
        </div>
      <label><br>Outline if you will be hiring people here: when you plan to hire, and what their role and salary will be.</label>
      <div class="row pt-3">
       <mat-form-field  class="full-width" appearance="fill">
        <textarea matInput
        [ngModel]="dataBplan?.bplanPersonnelPlan" 
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5" formControlName="bplanPersonnelPlan"></textarea>
    </mat-form-field>
  </div>
  <div>
    <button mat-button matStepperPrevious>Back</button>
    <button mat-button type="submit" matStepperNext>Next</button>
  </div>
      </form>
      </mat-step>
    <mat-step >
      <ng-template matStepLabel>All done!</ng-template>
     <!-- <p>Congratulations, you've built your business plan. If you haven't already, navigate to the Revenue Calculator to populate your Revenue Results.</p>-->
     <p>Congratulations, you've built your business plan. Download the completed plan and work wiith a business counselor if needed to incorporate your Financial Projections upon download.</p>
     <div class="btn-group pt-3 pr-3">
      <button class="block" mat-raised-button color="primary" id="printbtn" (click)="exportOnClick('pdf')">Download PDF</button>
     </div>
     <div class="btn-group pt-3 pr-3">
       <button class="block" mat-raised-button color="primary" id="printbtn" (click)="exportOnClick('docx')">Download DOCX</button>
     </div>
      <div>
        <button mat-button matStepperPrevious>Back</button>
      <!--  <button mat-button (click)="stepper.reset()">Reset</button>-->
      </div>
    </mat-step>
  </mat-vertical-stepper>
</div>
</div>



